module.exports = __webpack_public_path__ + "img/tile-type_jp.0103c7a.jpg";